import { createAsyncThunk } from '@reduxjs/toolkit'
import { http } from 'src/libs'

export const LoginAuth = createAsyncThunk(
  'LoginAuth',
  async (payload: any, thunkApi) => {
    try {
      const { response, error }: any = await http({
        method: 'POST',
        baseUrl: process.env.REACT_APP_API_BASE_URL,
        path: {
          url: 'SEND_CODE',
        },
        data: payload,
      })

      if (error?.status === 404) {
        return thunkApi.rejectWithValue(error)
      }

      if (error?.status) {
        return thunkApi.rejectWithValue(error)
      }

      return thunkApi.fulfillWithValue(response)
     } catch (err) {
      return thunkApi.rejectWithValue(err)
    }
  }
)
